module.exports = __webpack_public_path__ + "static/img/0541_5.e7b69b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0541_5.jpg
// module id = /eFa
// module chunks = 1